const noInnCases = [
    {
        "id": "7",
        "name": "Ινσουλίνες",
        "code": "B2",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "6",
        "name": "Παράγωγα αίματος",
        "code": "B1",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "5",
        "name": "Φάρμακα των οποίων η χορήγηση γίνεται με συσκευές που απαιτούν εκπαίδευση των ασθενών",
        "code": "A5",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "4",
        "name": "Φάρμακα για χρόνια εκφυλιστικά και αυτοάνοσα νοσήματα",
        "code": "A4",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "8",
        "name": "Εμβόλια",
        "code": "B3",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "3",
        "name": "Φάρμακα που απαιτούν ιατρική επίβλεψη ή ειδικά μέτρα προστασίας ή ειδική μεθοδολογία κατά την χορήγησή τους",
        "code": "A3",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "17",
        "name": "Φάρμακα για άσθμα",
        "code": "B11",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "18",
        "name": "Φάρμακα για ασθενείς με χρόνιες νόσους επαρκώς και αποτελεσματικώς ρυθμισμένους",
        "code": {},
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "14",
        "name": "Φάρμακα για επιληψία",
        "code": "B8",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "16",
        "name": "Φάρμακα για σχιζοφρένεια",
        "code": "B10",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "21",
        "name": "Μη αποζημιούμενο φάρμακο",
        "code": {},
        "isNegativeList": "true",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "15",
        "name": "Φάρμακα για ψύχωση",
        "code": "B9",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "12",
        "name": "Φάρμακα στενού φαρμακευτικού εύρους (narrow therapeutic range)",
        "code": "B6",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "13",
        "name": "Φάρμακα με υψηλή τοξικότητα (χημειοθεραπευτικά και παράγωγα)",
        "code": "B7",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "2",
        "name": "Φάρμακα για μεταμοσχευμένους και ανοσοκατασταλμένους",
        "code": "A2",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "10",
        "name": "Συνδυασμένα προϊόντα",
        "code": "B5",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "1",
        "name": "Φάρμακα που προκαλούν αλλεργίες και αντιδράσεις",
        "code": {},
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "9",
        "name": "Βιοτεχνολογικά φάρμακα",
        "code": "B4",
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "0",
        "name": "Χρόνιες νόσοι",
        "code": {},
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "false"
    },
    {
        "id": "22",
        "name": "Εμβόλια Απευαισθητοποίησης",
        "code": {},
        "isNegativeList": "false",
        "isPendingList": "false",
        "isDesensitizationVaccine": "true"
    },
    {
        "id": "23",
        "name": "Εν δυνάμει, μη αποζημιούμενο φάρμακο",
        "code": {},
        "isNegativeList": "false",
        "isPendingList": "true",
        "isDesensitizationVaccine": "false"
    }
]

export const getNoInnCasesOptions = () => {
    let arr = [];
    for (let obj of noInnCases) {
        arr.push({
            label: String(obj["name"]),
            value: String(obj["id"]),
        })
    }
    arr.sort((a, b) => String(a.label).localeCompare(b.label, "el"));
    return [{value: "", label: "Κενό"}, ...arr];
}